import React from 'react'
import { SubscriptionStatus } from './SubscriptionStatus'
import { ManageSubscription } from './ManageSubscription'
import { ReferralCard } from './ReferralCard'

export const SubscriptionSettings: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Subscription & Billing</h2>
        <p className="text-gray-600">Manage your HousePoints subscription and billing settings</p>
      </div>

      <SubscriptionStatus />
      <ManageSubscription />
      <ReferralCard />

      <div className="bg-gray-50 rounded-lg p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Need Help?</h3>
        <p className="text-gray-600 text-sm mb-4">
          If you have questions about your subscription or billing, we're here to help.
        </p>
        <a
          href="https://housepoints.ai/contact"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-blue-600 text-white px-6 py-2 rounded-lg text-sm font-medium hover:bg-blue-700 transition"
        >
          Contact Support
        </a>
      </div>
    </div>
  )
}
